import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlinedFlag, MdOutlineEventSeat } from "react-icons/md";
import { Box, ListItemIcon, MenuItem, Link, ListItemText } from "@mui/material";

export const purchaseCreditLanguages = {
  mainCardDescription:
    "A customizable spending account that allows you to utilize your tickets in a flexible way that best suits your needs.",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Select Your Games",
    description:
      "Select the games you wish to attend based on the amount of credit you have available.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Winnipeg Jets account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available by logging into your TN Ticket Central Account
        Manager at{" "}
        <Link
          href={"https://am.ticketmaster.com/tnse/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          https://am.ticketmaster.com/tnse/
        </Link>
        . Reach out to{" "}
        <Link
          href={"mailto:ticketsales@winnipegjets.com"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          ticketsales@winnipegjets.com
        </Link>{" "}
        for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Winnipeg Jets Passport work?",
    description:
      "The Winnipeg Jets Passport allows fans to use pre-purchased credit towards seats to any regular season games. Simply log into your Winnipeg Jets Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No you can come back to utilize your credit throughout the season. Your credit will expire at the end of the 2025-26 season.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "After you select games, you will be prompted to select seats from currently available inventory.",
  },
  {
    title: "Where are the ticket delivered?",
    description:
      "Tickets are delivered directly within your Winnipeg Jets Account Manager and will be available to be managed after August 5th.",
  },
];

export function WinnipegJetsTCLanguage() {
  return (
    <>
      By purchasing you are agreeing to the Winnipeg Jets{" "}
      <Link
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://ss-leagues.s3.amazonaws.com/Winnipeg%20Jets%20Passport%20%202025-26%20Terms%20and%20Conditions.pdf"
        target="_blank"
      >
        Terms and Conditions
      </Link>
      .
    </>
  );
}

export function WinnipegJetsHamburgerTCListItems() {
  return (
    <Box>
      <MenuItem
        onClick={() => {
          window.open(
            "https://ss-leagues.s3.amazonaws.com/Winnipeg%20Jets%20Passport%20%202025-26%20Terms%20and%20Conditions.pdf",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRounded fontSize="small" />
        </ListItemIcon>
        <ListItemText>Winnipeg Jets Terms and Conditions</ListItemText>
      </MenuItem>
    </Box>
  );
}
